import { chakra, Flex, Image, Text } from '@chakra-ui/react';
import usePeCompanyColor from 'hooks/modules/pe/usePeCompanyColor';
import AppCard from 'presentation/components/shared/card/AppCard';
import TagsRow from 'presentation/components/shared/TagsRow';
import { FC } from 'react';

export interface PeOrderShortGridItem {
  id: ID;
  name: string;
  subtitle1: string | null;
  subtitle2: string | null;
  tags: string[];
  color: string | null;
  gradientColor: string | null;
  companyLogo: string | null;
}

interface Props {
  peOrder: PeOrderShortGridItem;
  onCardClick: (orderId: ID) => void;
}

const PeOffersShortGridItem: FC<Props> = ({ peOrder, onCardClick, ...props }) => {
  const bgColor = usePeCompanyColor(peOrder.color, peOrder.gradientColor);

  return (
    <AppCard
      h="230px"
      py="10px"
      px="15px"
      background={bgColor}
      position="relative"
      onClick={() => onCardClick(peOrder.id)}
      cursor="pointer"
      {...props}
    >
      {peOrder.companyLogo && (
        <Image
          position="absolute"
          src={peOrder.companyLogo}
          right="10px"
          top="15px"
          w="90px"
          h="90px"
        />
      )}
      <Flex
        h="100%"
        zIndex={5}
        position="relative"
        flexDir="column"
        justifyContent="flex-end"
      >
        <Text noOfLines={3} color="white" fontWeight={700} fontSize="30px">
          {peOrder.name}
        </Text>
        {peOrder.subtitle1 && (
          <Text color="white" noOfLines={1} fontWeight={700}>
            {peOrder.subtitle1}
          </Text>
        )}
        {peOrder.subtitle2 && (
          <Text color="white" noOfLines={1} fontWeight={700} fontSize="26px">
            {peOrder.subtitle2}
          </Text>
        )}
        <TagsRow tags={peOrder.tags} mt="10px" />
      </Flex>
    </AppCard>
  );
};

export default chakra(PeOffersShortGridItem);
